export const arcRegisterButtons = {
    type: "none",
    itemId: "registerButtonContainer",
    className: "container",
    items: [
        {
            type: "submit",
            itemId: "backToLanding",
            label: "Back",
            className: "text-left col-md-6",
            value: "backToLanding"
        },
        {
            type: "submit",
            itemId: "submitRegister",
            label: "Submit",
            className: "text-right col-md-6",
            value: "submitRegisterForm"
        }
    ]
};
